import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
var unavailableStyles = css({
  width: '130px',
  margin: "0 auto ".concat("var(--ds-space-300, 24px)"),
  display: 'block'
});
export var UnavailableSVGOld = function UnavailableSVGOld(props) {
  var id = 'related-links-unavailable-svg';
  return jsx("svg", _extends({
    "data-testid": id,
    viewBox: "0 0 130 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    css: unavailableStyles
  }, props), jsx("g", {
    clipPath: "url(#clip0_230_7297)"
  }, jsx("rect", {
    width: "130",
    height: "120.308",
    transform: "translate(0 0.346191)",
    fill: "white",
    fillOpacity: "0.01"
  }), jsx("path", {
    d: "M42.3955 18.6676C41.9189 18.6687 41.4598 18.4883 41.1113 18.1631C40.7629 17.8379 40.5513 17.3923 40.5196 16.9168C40.5026 16.6703 40.5345 16.4229 40.6134 16.1888C40.6922 15.9547 40.8166 15.7385 40.9793 15.5525C41.142 15.3666 41.3398 15.2147 41.5613 15.1054C41.7829 14.9961 42.0239 14.9317 42.2704 14.9158L97.9222 12.2895C98.1654 12.2726 98.4096 12.3049 98.6401 12.3845C98.8706 12.4641 99.0827 12.5894 99.2636 12.7528C99.4446 12.9163 99.5907 13.1145 99.6933 13.3358C99.7959 13.557 99.8528 13.7967 99.8606 14.0404C99.8776 14.2868 99.8457 14.5342 99.7668 14.7684C99.6879 15.0025 99.5636 15.2187 99.4009 15.4046C99.2382 15.5905 99.0404 15.7425 98.8188 15.8518C98.5973 15.961 98.3563 16.0255 98.1098 16.0413L42.458 18.6676H42.3955Z",
    fill: "#CFD4DB"
  }), jsx("path", {
    d: "M52.3377 112.525C51.9318 112.525 51.5368 112.393 51.2121 112.15L14.3194 82.8233C13.9268 82.5045 13.6744 82.0449 13.616 81.5425C13.5576 81.0402 13.6978 80.5349 14.0067 80.1345C14.1585 79.9396 14.3484 79.7777 14.5649 79.6587C14.7815 79.5398 15.02 79.4664 15.2659 79.443C15.5118 79.4196 15.76 79.4466 15.995 79.5225C16.2301 79.5984 16.4472 79.7216 16.633 79.8844L53.5257 109.211C53.9142 109.519 54.1651 109.968 54.2236 110.46C54.2822 110.952 54.1437 111.447 53.8384 111.837C53.6516 112.052 53.4211 112.225 53.1623 112.343C52.9035 112.462 52.6223 112.524 52.3377 112.525Z",
    fill: "#CFD4DB"
  }), jsx("path", {
    d: "M114.93 75.9449C114.489 75.928 114.065 75.7654 113.726 75.4826C113.387 75.1999 113.151 74.8128 113.054 74.3817L103.049 20.7934C103.004 20.5512 103.007 20.3024 103.058 20.0613C103.109 19.8202 103.207 19.5915 103.346 19.3882C103.486 19.185 103.664 19.0112 103.87 18.8768C104.077 18.7424 104.308 18.65 104.55 18.6049C104.792 18.5596 105.041 18.5626 105.282 18.6135C105.523 18.6645 105.752 18.7624 105.955 18.9018C106.159 19.0412 106.332 19.2192 106.467 19.4258C106.601 19.6323 106.694 19.8633 106.739 20.1056L116.744 73.6939C116.798 73.9368 116.801 74.1883 116.754 74.4328C116.707 74.6772 116.61 74.9093 116.469 75.1146C116.329 75.3199 116.147 75.4941 115.936 75.6261C115.725 75.7582 115.489 75.8455 115.243 75.8824L114.93 75.9449Z",
    fill: "#B3BAC5"
  }), jsx("path", {
    d: "M103.925 23.2322C108 23.2322 111.303 19.9287 111.303 15.8536C111.303 11.7786 108 8.4751 103.925 8.4751C99.8499 8.4751 96.5464 11.7786 96.5464 15.8536C96.5464 19.9287 99.8499 23.2322 103.925 23.2322Z",
    fill: "#091E42"
  }), jsx("path", {
    d: "M73.973 33.2996C73.6216 33.2921 73.2789 33.1892 72.9816 33.002C72.6842 32.8147 72.4433 32.5502 72.2847 32.2366C72.0696 31.7887 72.0411 31.2739 72.2052 30.805C72.3693 30.3361 72.7127 29.9514 73.1601 29.7354L98.6098 17.2294C98.833 17.1086 99.0784 17.0344 99.3312 17.0112C99.5839 16.9881 99.8387 17.0164 100.08 17.0946C100.322 17.1728 100.545 17.2991 100.736 17.466C100.927 17.6329 101.082 17.8369 101.193 18.0655C101.303 18.2942 101.365 18.5428 101.376 18.7964C101.388 19.0499 101.347 19.3031 101.258 19.5406C101.168 19.7781 101.032 19.995 100.856 20.1781C100.68 20.3612 100.469 20.5068 100.236 20.606L74.7859 33.112C74.5317 33.2328 74.2543 33.2968 73.973 33.2996Z",
    fill: "#ECEEF1"
  }), jsx("path", {
    d: "M51.2122 108.461C50.7643 108.467 50.3291 108.313 49.985 108.026C49.641 107.739 49.4109 107.339 49.3363 106.897L37.0178 29.1726C36.9953 28.709 37.1455 28.2535 37.4394 27.8942C37.7332 27.5349 38.1498 27.2973 38.6086 27.2273C39.0675 27.1573 39.536 27.2599 39.9236 27.5152C40.3112 27.7706 40.5903 28.1606 40.7071 28.6098L53.0255 106.272C53.08 106.516 53.0815 106.769 53.0301 107.014C52.9786 107.258 52.8754 107.489 52.7273 107.691C52.5792 107.892 52.3896 108.059 52.1714 108.181C51.9532 108.303 51.7114 108.377 51.4623 108.398L51.2122 108.461Z",
    fill: "#B3BAC5"
  }), jsx("path", {
    d: "M35.517 31.3611C44.0815 31.3611 51.0244 24.4182 51.0244 15.8536C51.0244 7.28912 44.0815 0.346191 35.517 0.346191C26.9524 0.346191 20.0095 7.28912 20.0095 15.8536C20.0095 24.4182 26.9524 31.3611 35.517 31.3611Z",
    fill: "url(#paint0_linear_230_7297)"
  }), jsx("path", {
    d: "M11.8807 72.3809L11.1929 72.2559C10.9605 72.1605 10.7495 72.0194 10.5727 71.8409C10.3958 71.6625 10.2565 71.4503 10.1632 71.217C10.0699 70.9837 10.0244 70.7341 10.0294 70.4829C10.0344 70.2317 10.0899 69.984 10.1924 69.7547L29.2641 24.0452C29.4574 23.5912 29.8217 23.2317 30.2781 23.0444C30.7346 22.8572 31.2464 22.8573 31.7028 23.0447C31.933 23.1334 32.1428 23.2682 32.3191 23.4408C32.4955 23.6134 32.6347 23.8202 32.7284 24.0485C32.822 24.2768 32.8681 24.5218 32.8638 24.7685C32.8595 25.0152 32.8049 25.2585 32.7033 25.4834L13.6316 71.2554C13.477 71.5901 13.2302 71.8737 12.92 72.0731C12.6099 72.2724 12.2494 72.3792 11.8807 72.3809Z",
    fill: "#CFD4DB"
  }), jsx("path", {
    d: "M61.5297 71.4429H60.9669C60.4967 71.2983 60.1022 70.9747 59.8682 70.542C59.6343 70.1092 59.5797 69.6019 59.7163 69.1293L67.9702 40.3655C68.0353 40.127 68.1469 39.9037 68.2986 39.7084C68.4503 39.5132 68.639 39.3499 68.854 39.2279C69.069 39.1058 69.306 39.0275 69.5514 38.9974C69.7968 38.9673 70.0457 38.9859 70.2839 39.0523C70.5214 39.1165 70.7433 39.2284 70.9362 39.3811C71.1291 39.5338 71.289 39.7242 71.406 39.9406C71.5229 40.157 71.5947 40.395 71.6168 40.6401C71.6389 40.8851 71.6109 41.1321 71.5345 41.3659L63.343 70.1298C63.2221 70.5145 62.9804 70.85 62.6537 71.0865C62.3271 71.3231 61.9329 71.448 61.5297 71.4429Z",
    fill: "#ECEEF1"
  }), jsx("path", {
    d: "M105.488 79.8843C105.203 79.883 104.922 79.821 104.664 79.7024C104.405 79.5838 104.174 79.4113 103.987 79.1965L74.911 42.7415C74.6488 42.3488 74.5444 41.8717 74.6185 41.4054C74.6926 40.9391 74.9398 40.518 75.3108 40.2259C75.6817 39.9339 76.1492 39.7925 76.6198 39.8299C77.0905 39.8673 77.5297 40.0808 77.8499 40.4278L106.926 76.8829C107.232 77.2732 107.37 77.7684 107.312 78.2605C107.253 78.7525 107.002 79.2014 106.614 79.5091C106.289 79.7527 105.894 79.8843 105.488 79.8843Z",
    fill: "#CFD4DB"
  }), jsx("path", {
    d: "M9.94228 86.1375C15.4332 86.1375 19.8846 81.6862 19.8846 76.1952C19.8846 70.7042 15.4332 66.2529 9.94228 66.2529C4.45131 66.2529 0 70.7042 0 76.1952C0 81.6862 4.45131 86.1375 9.94228 86.1375Z",
    fill: "#0065FF"
  }), jsx("path", {
    d: "M15.8201 77.1331C15.3435 77.1342 14.8844 76.9538 14.5359 76.6286C14.1875 76.3034 13.9759 75.8578 13.9442 75.3823C13.9273 75.1308 13.9612 74.8785 14.0439 74.6404C14.1267 74.4023 14.2566 74.1834 14.4258 73.9966C14.5951 73.8099 14.8002 73.6591 15.029 73.5534C15.2579 73.4477 15.5056 73.3892 15.7575 73.3813L56.9023 71.1928C57.3998 71.1679 57.8869 71.3417 58.2563 71.6759C58.6257 72.0101 58.8472 72.4774 58.872 72.9749C58.8969 73.4724 58.7231 73.9594 58.3889 74.3288C58.0547 74.6982 57.5874 74.9197 57.0899 74.9446L15.9451 77.1331H15.8201Z",
    fill: "#ECEEF1"
  }), jsx("path", {
    d: "M52.3378 120.592C57.8288 120.592 62.2801 116.14 62.2801 110.649C62.2801 105.158 57.8288 100.707 52.3378 100.707C46.8468 100.707 42.3955 105.158 42.3955 110.649C42.3955 116.14 46.8468 120.592 52.3378 120.592Z",
    fill: "#6554C0"
  }), jsx("path", {
    d: "M58.1529 109.461C57.7594 109.461 57.3752 109.342 57.0513 109.118C56.7274 108.895 56.4791 108.578 56.3395 108.21C56.2612 107.976 56.2297 107.729 56.2471 107.483C56.2644 107.237 56.3301 106.997 56.4405 106.776C56.5508 106.555 56.7037 106.358 56.8902 106.197C57.0768 106.035 57.2934 105.912 57.5276 105.834L116.306 85.2619C116.778 85.1044 117.294 85.141 117.74 85.3638C118.186 85.5867 118.524 85.9774 118.682 86.45C118.84 86.9226 118.803 87.4385 118.58 87.8841C118.357 88.3297 117.967 88.6686 117.494 88.8261L58.7157 109.336L58.1529 109.461Z",
    fill: "#CFD4DB"
  }), jsx("path", {
    d: "M112.241 103.145C122.049 103.145 130 95.1947 130 85.387C130 75.5792 122.049 67.6284 112.241 67.6284C102.434 67.6284 94.4829 75.5792 94.4829 85.387C94.4829 95.1947 102.434 103.145 112.241 103.145Z",
    fill: "url(#paint1_linear_230_7297)"
  }), jsx("path", {
    d: "M60.1539 80.4473C64.229 80.4473 67.5325 77.1438 67.5325 73.0687C67.5325 68.9937 64.229 65.6902 60.1539 65.6902C56.0789 65.6902 52.7754 68.9937 52.7754 73.0687C52.7754 77.1438 56.0789 80.4473 60.1539 80.4473Z",
    fill: "#091E42"
  }), jsx("path", {
    d: "M71.4718 45.4305C76.9628 45.4305 81.4141 40.9791 81.4141 35.4882C81.4141 29.9972 76.9628 25.5459 71.4718 25.5459C65.9809 25.5459 61.5295 29.9972 61.5295 35.4882C61.5295 40.9791 65.9809 45.4305 71.4718 45.4305Z",
    fill: "#6554C0"
  })), jsx("defs", null, jsx("linearGradient", {
    id: "paint0_linear_230_7297",
    x1: "42.41",
    y1: "29.5483",
    x2: "28.7488",
    y2: "1.66232",
    gradientUnits: "userSpaceOnUse"
  }, jsx("stop", {
    stopColor: "#0065FF"
  }), jsx("stop", {
    offset: "0.16",
    stopColor: "#0166FF"
  }), jsx("stop", {
    offset: "0.3",
    stopColor: "#0A6CFF"
  }), jsx("stop", {
    offset: "0.52",
    stopColor: "#247BFF"
  }), jsx("stop", {
    offset: "0.81",
    stopColor: "#4D94FF"
  }), jsx("stop", {
    offset: "0.96",
    stopColor: "#66A3FF"
  })), jsx("linearGradient", {
    id: "paint1_linear_230_7297",
    x1: "100.74",
    y1: "76.6599",
    x2: "128.453",
    y2: "98.6882",
    gradientUnits: "userSpaceOnUse"
  }, jsx("stop", {
    stopColor: "#0065FF"
  }), jsx("stop", {
    offset: "0.16",
    stopColor: "#096AFF"
  }), jsx("stop", {
    offset: "0.41",
    stopColor: "#2078FF"
  }), jsx("stop", {
    offset: "0.73",
    stopColor: "#468FFF"
  }), jsx("stop", {
    offset: "0.96",
    stopColor: "#66A3FF"
  })), jsx("clipPath", {
    id: "clip0_230_7297"
  }, jsx("rect", {
    width: "130",
    height: "120.308",
    fill: "white",
    transform: "translate(0 0.346191)"
  }))));
};